module.exports = __webpack_public_path__ + "static/image/help_center_start.svg?a311febf423f4c16a8cc9c89265c1f21";